import request from "../utils/request";

const CLIENT = process.env.REACT_APP_CLIENT
const SECRET = process.env.REACT_APP_SECRET

function Login(username, password, recaptcha) {
    return request({
        url: "/user/login",
        method: "POST",
        data: {
            username,
            password,
            "g-recaptcha-response": recaptcha
        },
        auth: {
            username: CLIENT,
            password: SECRET
        },
    })
}

const AuthenticationService = {
   Login,
};

export default AuthenticationService;